import { Component, CUSTOM_ELEMENTS_SCHEMA, input, signal } from '@angular/core';

@Component({
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-listing-details-accordion',
  templateUrl: './accordion.html',
})
export class ListingDetailsAccordion {
  public readonly accordionId = input.required<string>();
  public readonly checkingForToken = input<boolean>(false);
  public readonly expandable = input(true);
  public readonly title = input.required<string>();

  public readonly isOpen = signal(false);

  public toggle(): void {
    if (!this.checkingForToken()) {
      this.isOpen.update((v) => !v);
    }
  }
}
